var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegulations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.405273,
    width: 41.1899,
    height: 41.1899,
    rx: 18.3003,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3427 13.0158C20.8466 12.9166 20.3357 12.9166 19.8396 13.0158C18.7372 13.2363 17.7872 13.9298 17.2412 14.9125L12.0863 24.1914C11.7889 24.7267 11.6328 25.3289 11.6328 25.9413C11.6328 27.9313 13.246 29.5446 15.2361 29.5446H25.9462C27.9362 29.5446 29.5495 27.9313 29.5495 25.9413C29.5495 25.3289 29.3934 24.7267 29.096 24.1914L23.9411 14.9125C23.3951 13.9298 22.4451 13.2363 21.3427 13.0158ZM20.5915 22.4603C20.2463 22.4603 19.9665 22.1805 19.9665 21.8353V18.502C19.9665 18.1568 20.2463 17.877 20.5915 17.877C20.9366 17.877 21.2165 18.1568 21.2165 18.502V21.8353C21.2165 22.1805 20.9366 22.4603 20.5915 22.4603ZM21.2165 24.752C21.2165 25.0971 20.9366 25.377 20.5915 25.377C20.2463 25.377 19.9665 25.0971 19.9665 24.752V24.3353C19.9665 23.9901 20.2463 23.7103 20.5915 23.7103C20.9366 23.7103 21.2165 23.9901 21.2165 24.3353V24.752Z",
    fill: "#797A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulations);
export default __webpack_public_path__ + "static/media/regulations.6ab3a1c36053b47b93b1025765389e6d.svg";
export { ForwardRef as ReactComponent };